import { toast } from 'react-toastify'

interface toastifyProps {
  message?: string,
  type?: 'ERROR' | 'INFO' | 'SUCCESS' | 'DEFAULT' | 'WARNING',
  position?: 'TOP_RIGHT'|'BOTTOM_CENTER'

}
const toastify = ({ message, type = "DEFAULT", position ='TOP_RIGHT' }: toastifyProps) => {
  toast(`${message}`, {
    type: toast.TYPE[`${type}`],
    position : toast.POSITION[`${position}`]
  });
}

const useToastify = {
  toastify
}

export default useToastify